import React from "react";
import { Empty } from 'antd';

export default function EmptyPage() {
  return (
    <div style={{marginTop: 10, marginBottom: 10}}>
      <Empty description="" />
    </div>
  )
}